export default __webpack_public_path__ + "static/media/infoIcon.ed545f48.svg";